/* eslint-disable react/display-name */
import { Box, Container, Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { makeStyles } from "makeStyles"
import { BsChevronDown } from "react-icons/bs"
import { FiPhoneCall } from "react-icons/fi"
import { MdMail } from "react-icons/md"
import { AiFillCheckCircle } from "react-icons/ai"
import { RiSafe2Line, RiBillLine } from "react-icons/ri"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { de as deLocale } from "date-fns/locale/de"

import Button from "components/Buttons/Button"
import { Email, Phone } from "components/i18n/Contact"
import SEO from "components/SEO"
import Link from "components/i18n/Link"

import useToggle from "@secureo/common/hooks/useToggle"

import Form from "containers/RegisterProducts/Form"

import Image from "next/image"
import HeaderImage from "/images/produktregistrierung.jpeg"

const infos = [
	{
		question: "Wo kann ich Secureo Produkte kaufen?",
		answer: () => (
			<div>
				Sie erhalten unsere hochwertigen Tresore, Safes und Zylinder online auf{" "}
				<a href="https://www.tresoro.de" target="_blank" rel="noreferrer">
					Tresoro.de
				</a>
				,{" "}
				<a href="https://www.tresoro.at" target="_blank" rel="noreferrer">
					Tresoro.at
				</a>
				,{" "}
				<a href="https://www.digitalzylinder-shop.com" target="_blank" rel="noreferrer">
					Digitalzylinder-shop.com
				</a>
				,{" "}
				<a href="https://safehero.com" target="_blank" rel="noreferrer">
					SafeHero.com
				</a>{" "}
				und{" "}
				<a href="https://www.amazon.de/secureo" target="_blank" rel="noreferrer">
					Amazon
				</a>
			</div>
		),
	},
	{
		question: "Warum sollte ich mich für einen Secureo Safe entscheiden?",
		answer: () => (
			<div>Große Auswahl, Günstige Preise, Gratis Lieferung, Sicheres Online-Shopping</div>
		),
	},
	{
		question: "Wo kann ich Ersatzteile bestellen?",
		answer: () => (
			<div>
				<Link href="/spare-parts">Hier</Link> können Sie ganz mühelos ein Ersatzteil online
				anfordern
			</div>
		),
	},
]

const benefits = [
	{
		title: (
			<div>
				<strong>Verbesserter Produkt-Support:</strong> Erhalten Sie schnellere und
				individuell auf Sie zugeschnittenen Beratung.
			</div>
		),
	},
	{
		title: (
			<div>
				{" "}
				<strong>Spezielle Angebote:</strong> Profitieren Sie von exklusiven Angeboten für
				registrierte Nutzer.
			</div>
		),
	},
	{
		title: (
			<div>
				{" "}
				Holen Sie mit unseren <strong>Tipps und Tricks</strong> das Beste aus Ihrem Produkt
				heraus.
			</div>
		),
	},
]

const useStyles = makeStyles()(() => ({
	wrapper: {
		display: "flex",
		"@media only screen and (max-width: 1260px)": {
			display: "block",
		},
	},
	leftColumn: {
		display: "block",
		width: "60%",
		marginLeft: "-10%",
		marginRight: "-5%",
		height: 700,
		background: "#042C33",
		transform: "skew(-8deg)",
		position: "relative",
		zIndex: 3,
		"@media only screen and (max-width: 1260px)": {
			width: "100%",
			marginLeft: "0%",
			marginRight: "0%",
			height: "auto",
			transform: "skew(0deg)",
		},
	},
	leftColumnContent: {
		maxWidth: 350,
		marginLeft: "45%",
		marginRight: "auto",
		transform: "skew(8deg)",
		"@media only screen and (max-width: 1260px)": {
			marginLeft: "auto",
			transform: "skew(0deg)",
			maxWidth: 600,
		},
	},
	rightColumn: {
		background: "none",
		width: "65%",
		height: 700,
		overflow: "scroll",
		position: "relative",
		"@media only screen and (max-width: 1260px)": {
			width: "100%",
			height: "auto",
		},
	},
	responsiveCardMargin: {
		margin: "50px 0px",
		"@media only screen and (max-width: 960px)": {
			margin: "15px 0px",
		},
	},
	hideOnMobile: {
		display: "block",
		"@media only screen and (max-width: 960px)": {
			display: "none !important",
		},
	},
}))

const InformationForRegister = () => {
	const infos = [
		{
			icon: <RiSafe2Line size="1.7rem" color="#009CAC" />,
			title: "Ihren Tresor aus unserer Produktliste auswählen",
		},
		{
			icon: <RiBillLine size="1.7rem" color="#009CAC" />,
			title: "Rechnung hochladen und Kaufdetails angeben",
		},
		{
			icon: <AiFillCheckCircle size="1.7rem" color="#009CAC" />,
			title: "Fertig - Ihr Produkt ist registriert!",
		},
	]
	return (
		<div style={{ maxWidth: "100%" }}>
			<div style={{ display: "flex", flexFlow: "wrap" }}>
				{infos.map((info, i) => {
					return (
						<Box mb={3} key={i} style={{ maxWidth: 250 }}>
							<Box mb={1}>{info.icon}</Box>
							<strong style={{ color: "#fff" }}>{info.title}</strong>
						</Box>
					)
				})}
			</div>
		</div>
	)
}

const RegisterProductsPage = () => {
	const { classes } = useStyles()
	const [showRegisterForm, toggleShowRegisterForm] = useToggle(false)

	return (
		<>
			<SEO
				asPath={"/register-products"}
				title="Produkt registrieren"
				appendLocalizedShopNameWithPipe
			/>
			{/* NEW */}
			<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
				<Box>
					<div className={classes.wrapper}>
						<div className={classes.leftColumn}>
							<Container>
								<Box py={5} className={classes.leftColumnContent}>
									<h1 style={{ color: "#fff", fontWeight: 100 }}>
										Produkt registrieren
									</h1>
									<p
										style={{
											maxWidth: showRegisterForm ? 350 : 500,
											color: "#fff",
											opacity: 0.75,
											marginTop: 20,
											marginBottom: 50,
										}}
									>
										Registrieren Sie hier Ihr Sicherheitsprodukt von Secureo und
										profitieren Sie von zahlreichen Vorteilen
									</p>
									<div className={classes.hideOnMobile}>
										{showRegisterForm && <InformationForRegister />}
									</div>
									{!showRegisterForm && (
										<Button
											color="primary"
											onClick={toggleShowRegisterForm}
											style={{ maxWidth: 220 }}
										>
											Produkt registrieren
										</Button>
									)}
								</Box>
							</Container>
						</div>
						<Box className={classes.rightColumn}>
							<div style={{ maxWidth: 700, marginLeft: "auto", marginRight: "auto" }}>
								{showRegisterForm ? (
									<Box py={5} style={{ height: "100%" }}>
										<Container>
											<Form />
										</Container>
									</Box>
								) : (
									<Box style={{ zIndex: 2, position: "relative" }}>
										<Box
											p={5}
											style={{
												background: "white",
												borderRadius: 5,
												maxWidth: 400,
												marginLeft: "auto",
												marginRight: "auto",
												color: "black",
												boxShadow: "0 15px 10px rgba(0, 0, 0, 0.20)",
											}}
											className={`${classes.responsiveCardMargin} ${classes.hideOnMobile}`}
										>
											<h2 style={{ fontSize: 20 }}>
												Warum sollten Sie Ihr Produkt registrieren?
											</h2>
											{benefits.map((benefit, i) => {
												return (
													<Box
														mb={3}
														key={i}
														style={{
															display: "flex",
															alignItems: "center",
														}}
													>
														<div style={{ width: "9%" }}>
															<AiFillCheckCircle
																size="1.5rem"
																color="#44B87A"
															/>
														</div>
														<div style={{ width: "80%" }}>
															{benefit.title}
														</div>
													</Box>
												)
											})}
										</Box>
									</Box>
								)}
							</div>
							<div className={classes.hideOnMobile}>
								{!showRegisterForm && (
									<Image
										alt="Kontakt"
										src={HeaderImage}
										quality={100}
										fill
										sizes="100vw"
										style={{
											objectFit: "cover",
										}}
									/>
								)}
							</div>
						</Box>
					</div>
				</Box>
				<Box py={10} style={{ background: "#182F37" }}>
					<Container>
						<Grid container spacing={3} style={{ color: "#fff" }}>
							<Grid item xs={12} style={{ textAlign: "center" }}>
								<Box my={5}>
									<h3 style={{ fontSize: 26 }}>
										Benötigen Sie Hilfe? Wir beraten Sie gerne
									</h3>
								</Box>
							</Grid>
							<Grid item xs={12} md={5}>
								<div>
									<strong>Kontaktinformationen</strong>
								</div>
								<Box
									mt={2}
									style={{ opacity: 0.75, display: "flex", alignItems: "center" }}
								>
									<FiPhoneCall
										size="1.2rem"
										color="#fff"
										style={{ marginRight: 10 }}
									/>{" "}
									<Phone />
								</Box>
								<Box
									mt={2}
									mb={5}
									style={{ opacity: 0.75, display: "flex", alignItems: "center" }}
								>
									<MdMail
										size="1.2rem"
										color="#fff"
										style={{ marginRight: 10 }}
									/>{" "}
									<Email />
								</Box>
							</Grid>
							<Grid item xs={12} md={7}>
								{infos.map((info) => {
									const Answer = info.answer
									return (
										<Accordion
											key={info.question}
											style={{
												background: "none",
												boxShadow: "none",
												color: "#fff",
												borderBottom: "1px solid rgba(255,255,255, 0.3)",
											}}
										>
											<AccordionSummary
												expandIcon={
													<BsChevronDown size="1.2rem" color="#fff" />
												}
												aria-controls="panel1a-content"
												id="panel1a-header"
											>
												<div>
													<strong
														dangerouslySetInnerHTML={{
															__html: info.question,
														}}
													/>
												</div>
											</AccordionSummary>
											<AccordionDetails>
												<Answer />
											</AccordionDetails>
										</Accordion>
									)
								})}
							</Grid>
						</Grid>
					</Container>
				</Box>
			</LocalizationProvider>
		</>
	)
}

export default RegisterProductsPage
